import { Spin } from 'antd';
import React, { FC, useEffect, useState } from 'react';
import './handbooks.scss';
import { capitalizeFirstLetter, getLangValue, localize } from '/react4xp/mixins/helpers';
import PartWrapper from '/react4xp/mixins/ui/part-wrapper';
import { getUploadedDictionaries } from '/react4xp/parts/handbooks/actions';
import CardsIcon from '/react4xp/parts/handbooks/assets/svg/grid.svg';
import RowsIcon from '/react4xp/parts/handbooks/assets/svg/list.svg';
import { Card } from '/react4xp/parts/handbooks/components/card';
import { Row } from '/react4xp/parts/handbooks/components/row';
import { Dictionary, IUploadedData } from '/react4xp/parts/handbooks/handbooks.types';
import { getCardImages } from '/react4xp/parts/handbooks/helpers';
import Search from '/react4xp/parts/handbooks/search/Search';

export const cardImages = getCardImages();
const DOWNLOAD_URL = '/services/isnaportal/open-api/download-uploaded-dictionary/';

const Handbooks: FC = (props: any) => {
    const [dictionaries, setDictionaries] = useState<Dictionary[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [filterText, setFilterText] = useState<string | null>('');
    const [mode, setMode] = useState<'cards' | 'rows'>('rows');

    const language = getLangValue(props.language);

    useEffect(() => {
        const savedMode = localStorage.getItem('mode');
        if (savedMode) {
            setMode(savedMode as 'cards' | 'rows');
        }
        onLoadedData();
    }, []);

    const onLoadedData = async () => {
        setIsLoading(true);

        let automatedList: Dictionary[] = [];

        try {
            if (!props.config.isHideAutomatedList) {
                // Сначала вызываем getAutomatedDictionaries
                // const {data: automated} = await getAutomatedDictionaries();
                //
                // automatedList = automated.reduce(
                //     (acc: Dictionary[], item: IAutomatedData) => {
                //         const dictData = cardImages[item.code];
                //         if (dictData) {
                //             acc.push({
                //                 imageUrl: dictData.src,
                //                 link: window.location.href + dictData.path,
                //                 source: 'ibd',
                //                 title: item[language],
                //             });
                //         }
                //         return acc;
                //     },
                //     []
                // );

                Object.keys(cardImages).forEach((x) => {
                    const dictData = cardImages[x];

                    if (!dictData.source && !dictData.isHidden) {
                        automatedList.push({
                            imageUrl: dictData.src,
                            link: window.location.href + dictData.path,
                            source: 'ibd',
                            title: dictData.name,
                        });
                    }
                });
            }

            // Затем вызываем getUploadedDictionaries
            const { data: uploaded } = await getUploadedDictionaries();

            const uploadedList: Dictionary[] = uploaded.reduce(
                (acc: Dictionary[], item: IUploadedData) => {
                    const link =
                        DOWNLOAD_URL + item[`metaDocument${capitalizeFirstLetter(language)}Id`];
                    if (link) {
                        acc.push({
                            imageUrl: cardImages.uploaded.src,
                            link,
                            source: 'uploaded',
                            title: item.description, // TODO: get proper name after BE returns localized titles
                        });
                    }
                    return acc;
                },
                []
            );

            // Объединяем списки и обновляем состояние
            setDictionaries(automatedList.concat(uploadedList));
        } finally {
            setIsLoading(false);
        }
    };

    const toggleSetMode = () => {
        const newMode = mode === 'cards' ? 'rows' : 'cards';
        setMode(newMode);
        localStorage.setItem('mode', newMode);
    };

    const handleFilterChange = ({ target: { value } }: any) => {
        setFilterText(value);
    };

    const filteredData = filterText
        ? dictionaries.filter((item) => item.title.toLowerCase().includes(filterText.toLowerCase()))
        : dictionaries;

    return (
        <div className="handbooks half-back">
            <div className="container">
                <Search
                    label={localize('handbooks-search', props.translations)}
                    onChange={handleFilterChange}
                    translations={props.translations}
                />
                <div
                    className="handbooks-switch"
                    onClick={toggleSetMode}
                >
                    <div className="rows-icon">
                        <RowsIcon />
                    </div>
                    <div className="cards-icon">
                        <CardsIcon />
                    </div>
                    {mode === 'rows' && (
                        <div className="circle checked">
                            <RowsIcon />
                        </div>
                    )}
                    {mode === 'cards' && (
                        <div className="circle unchecked">
                            <CardsIcon />
                        </div>
                    )}
                </div>
                <div className={mode === 'cards' ? `handbooks-cards` : 'rows'}>
                    {isLoading && <Spin size="large" />}
                    {filteredData.map((dictionary) =>
                        mode === 'cards' ? (
                            <Card
                                key={dictionary.title}
                                dictionary={dictionary}
                            />
                        ) : (
                            <Row
                                key={dictionary.title}
                                dictionary={dictionary}
                            />
                        )
                    )}

                    {filteredData.length === 0 && (
                        <div className="response">
                            <div className="response__total">
                                {localize('notification.no-data', props.translations)}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default (props) => (
    <PartWrapper {...props}>
        <Handbooks {...props} />
    </PartWrapper>
);
